module.exports = __webpack_public_path__ + "img/logo_blue.e7ee5260.png";